var React = require('react');

function LinkGray (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-421 -599)"},[React.createElement("rect",{"width":"22","height":"22","transform":"translate(421 599)","fill":"#fff","key":0}),React.createElement("g",{"transform":"translate(420 597.999)","key":1},[React.createElement("path",{"d":"M8.465,11.293a3.072,3.072,0,0,1,4.242,0l.707.707,1.414-1.414-.707-.707a5,5,0,0,0-7.071,0L4.929,12A5,5,0,0,0,12,19.071l.707-.707L11.293,16.95l-.707.707a3,3,0,0,1-4.243-4.243l2.122-2.12Z","fill":"#b1b1b1","key":0}),React.createElement("path",{"d":"M12,4.93l-.707.708,1.414,1.414.707-.707a3,3,0,0,1,4.243,4.243l-2.122,2.12a3.07,3.07,0,0,1-4.242,0L10.586,12,9.172,13.416l.707.707a5,5,0,0,0,7.07,0L19.071,12A5,5,0,0,0,12,4.931Z","fill":"#b1b1b1","key":1})])]));
}

LinkGray.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = LinkGray;

LinkGray.default = LinkGray;
